import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardHeader,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Label from '../../../components/Label';

const fEur = (n) =>
  new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);

export default function OneTimePaymentsSection({ items, total, activeCount }) {
  const rows = items || [];

  return (
    <Card>
      <CardHeader
        title="Pagos únicos"
        subheader={
          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            <Typography variant="body2" color="text.secondary">
              {activeCount ?? rows.length} suscripción{(activeCount ?? rows.length) === 1 ? '' : 'es'} activas
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total: <strong>{fEur(total)}</strong>
            </Typography>
          </Stack>
        }
      />
      {rows.length === 0 ? (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            No hay pagos únicos registrados.
          </Typography>
        </Box>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Fuente</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Producto</TableCell>
                <TableCell align="right">Asientos</TableCell>
                <TableCell align="right">EUR</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} hover>
                  <TableCell>
                    <Label color={r.source === 'manual' ? 'default' : 'info'}>{r.source || 'manual'}</Label>
                  </TableCell>
                  <TableCell>{r.customerEmail || '—'}</TableCell>
                  <TableCell>{r.productName || '—'}</TableCell>
                  <TableCell align="right">{r.qty ?? '—'}</TableCell>
                  <TableCell align="right">{fEur(r.amountEUR ?? r.cycleAmountEUR)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  );
}

OneTimePaymentsSection.propTypes = {
  items: PropTypes.array,
  total: PropTypes.number,
  activeCount: PropTypes.number,
};
